import type { Armor } from '../data/archive';

export function ArmorSchematic({ armor }: { armor: Armor }) {
  const heavy = armor.form === 'heavy';
  const rough = armor.form === 'forge';
  const nano = armor.form === 'nano' || armor.form === 'legacy';
  return (
    <svg className={`armor-schematic armor-${armor.form}`} viewBox="0 0 480 600" role="img" aria-label={`${armor.mark} ${armor.name} 原创矢量结构示意`}>
      <defs>
        <linearGradient id="plate" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4c080b" />
          <stop offset=".46" stopColor="#a90f16" />
          <stop offset="1" stopColor="#260608" />
        </linearGradient>
        <linearGradient id="gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f3c86a" />
          <stop offset=".5" stopColor={armor.accent} />
          <stop offset="1" stopColor="#6c4618" />
        </linearGradient>
        <radialGradient id="armorCoreGradient">
          <stop offset="0" stopColor="#fff" />
          <stop offset=".25" stopColor="#9bf8ff" />
          <stop offset="1" stopColor="#0b7481" stopOpacity=".1" />
        </radialGradient>
        <filter id="coreGlow"><feGaussianBlur stdDeviation="7" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
      </defs>
      <g className="schematic-grid" opacity=".28">
        {Array.from({ length: 9 }).map((_, i) => <line key={`v${i}`} x1={40 + i * 50} y1="40" x2={40 + i * 50} y2="560" />)}
        {Array.from({ length: 11 }).map((_, i) => <line key={`h${i}`} x1="40" y1={50 + i * 50} x2="440" y2={50 + i * 50} />)}
      </g>
      <g className="scan-rings" fill="none" stroke="#9bf8ff" opacity=".4">
        <ellipse cx="240" cy="302" rx="173" ry="242" strokeDasharray="4 12" />
        <ellipse cx="240" cy="302" rx="126" ry="196" strokeDasharray="2 18" />
      </g>
      <g className="armor-body" stroke="#e7b755" strokeWidth={rough ? 4 : 2} strokeLinejoin="round">
        <path fill="url(#plate)" d="M193 78 217 54h46l25 24 10 73-33 28h-50l-33-28z" />
        <path fill="url(#gold)" d="m189 95 51-23 52 23-6 31-46-12-45 12z" opacity=".9" />
        <path fill="#080808" d="m199 126 41-9 42 9-11 37h-62z" />
        <path fill="url(#plate)" d={heavy ? 'M112 190 182 162h116l73 28 46 107-50 34-34-82-30 82H174l-30-82-32 82-54-34z' : 'M135 188 187 163h106l52 25 31 93-43 24-31-70-18 86h-88l-18-86-31 70-43-24z'} />
        <path fill="url(#gold)" d="m174 184 66 46 66-46 13 43-79 53-79-53z" />
        <path fill="url(#plate)" d="m187 314 53-19 53 19 24 132-39 38h-76l-39-38z" />
        <path fill="url(#gold)" d="m190 352 50 22 51-22-6 38-45 19-44-19z" opacity=".78" />
        <path fill="url(#plate)" d={heavy ? 'm109 296 54 7-12 156-55 78-35-22 43-95z' : 'm113 284 45 15-15 145-39 79-28-16 31-99z'} />
        <path fill="url(#plate)" d={heavy ? 'm371 296-54 7 12 156 55 78 35-22-43-95z' : 'm367 284-45 15 15 145 39 79 28-16-31-99z'} />
        <path fill="url(#plate)" d="m191 454 42 25-8 71-49 19-19-24z" />
        <path fill="url(#plate)" d="m289 454-42 25 8 71 49 19 19-24z" />
      </g>
      <g className="core-pulse" filter="url(#coreGlow)">
        <circle cx="240" cy="274" r={nano ? 34 : 29} fill="url(#armorCoreGradient)" />
        <circle cx="240" cy="274" r={nano ? 20 : 16} fill="none" stroke="#fff" strokeWidth="2" strokeDasharray="4 5" />
      </g>
      <g className="detail-lines" fill="none" stroke="#9bf8ff" opacity=".8">
        <path d="M58 120h75l35 41"/><circle cx="58" cy="120" r="4" fill="#9bf8ff"/>
        <path d="M422 433h-71l-24-37"/><circle cx="422" cy="433" r="4" fill="#9bf8ff"/>
      </g>
      <text x="50" y="108" className="svg-label">STRUCTURE</text>
      <text x="350" y="422" className="svg-label">OUTPUT</text>
    </svg>
  );
}
